export default {
    data() {
        return {
            success: {
                country: false,
                password: false,
                mobile: false,
                tos: false
            },
            error: {
                country: "",
                mobile: "",
                password: "",
                tos: ""
            },
            errorMessages: {
                countryRequired: {
                    el: "Απαιτείται χώρα",
                    en: "Country is required",
                    it: "Il paese è richiesto"
                },
                mobileRequired: {
                    el: "Απαιτείται κινητό τηλέφωνο",
                    en: "Mobile Phone is required",
                    it: "È richiesto un telefono cellulare"
                },
                mobileLength: {
                    el: "Το κινητό χρήστη πρέπει να έχει μήκος μεταξύ 7 και 12 χαρακτήρων.",
                    en: "User Mobile must be between 7 and 12 characters long",
                    it: "Il cellulare dell'utente deve avere una lunghezza compresa tra 7 e 12 caratteri."
                },
                mobileFirstNumbers: {
                    el: "Το κινητό τηλέφωνο πρέπει να αρχίζει με 69",
                    en: "Mobile Phone must begin with 69",
                    it: "Il telefono cellulare deve iniziare con 69"
                },
                tosRequired: {
                    el: "Πρέπει να αποδεχτείτε τους όρους των υπηρεσιών για να προχωρήσετε",
                    en: "You must accept terms of services to proceed",
                    it: "Per procedere è necessario accettare i termini dei servizi"
                },
                passwordRequired: {
                    el: "Απαιτείται κωδικός πρόσβασης",
                    en: "Password is required",
                    it: "La password è necessaria"
                },
                passwordLength: {
                    el: "Ο κωδικός πρόσβασης πρέπει να αποτελείται από τουλάχιστον 5 χαρακτήρες",
                    en: "Password must be at least 5 characters long",
                    it: "La password deve essere di almeno 5 caratteri"
                }
            }
        };
    },

    computed: {
        valid() {
            return (
                this.success.country && this.success.mobile && (this.success.password || this.success.tos)
            );
        },
        selectedCountry () {
            return (this.countries||[]).find(x => x.country_id == this.storeDetails.country_id)||{}
        }
    },

    methods: {
        validateCountry() {
            if (!this.storeDetails.country_id) {
                this.error.country = this.errorMessages.countryRequired[
                    this.lang
                ];
            } else {
                this.error.country = "";
            }
        },

        validateMobile() {
            this.success.mobile =false
            if (!this.mobile) {
                this.error.mobile = this.errorMessages.mobileRequired[
                    this.lang
                ];
            } else if (this.mobile.length < 7 || this.mobile.length > 12 ) {
                this.error.mobile = this.errorMessages.mobileLength[this.lang];
            } else {
                this.error.mobile = "";
                this.success.mobile = true
            }
        },
        validatePassword() {
            if (!this.password) {
                this.error.password = this.errorMessages.passwordRequired[
                    this.lang
                ];
            } else if (this.password.length < 5) {
                this.error.password = this.errorMessages.passwordLength[
                    this.lang
                ];
            } else {
                this.error.password = "";
            }
        },

        validateTos() {
            if (!this.tos) {
                this.error.tos = this.errorMessages.tosRequired[this.lang];
            } else {
                this.error.tos = "";
            }
        }
    },

    watch: {
        ["storeDetails.country_id"](val) {
            if(val && this.mobile) this.validateMobile()
            this.success.country = !!val;
        },

        ["mobile"](val) {
            if (val) {
                this.success.mobile = val.length >= 7 && val.length <= 12
             
            } else {
                this.success.mobile = false;
            }
        },

        ["password"]: {
            handler(val) {
                this.success.password = val?.length >= 5;
            }
        },

        ["tos"]: {
            handler(val) {
                this.success.tos = !!val;
            }
        }
    }
};
